function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.07 14.24c-.29.29-.75.29-1.03 0a.718.718 0 010-1.03c2-2 2-5.25 0-7.24-2-1.99-5.25-2-7.24 0-1.99 2-2 5.25 0 7.24.29.29.29.75 0 1.03-.29.29-.75.29-1.03 0-2.57-2.57-2.57-6.75 0-9.31 2.57-2.56 6.75-2.57 9.31 0a6.594 6.594 0 01-.01 9.31z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M19.07 4.93a6.585 6.585 0 01-3.09 11.05c.53-2.16-.05-4.53-1.74-6.22a6.564 6.564 0 00-6.22-1.74c.28-1.13.85-2.21 1.74-3.09a6.585 6.585 0 019.31 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.93 9.76c.29-.29.75-.29 1.03 0 .29.29.29.75 0 1.03-2 2-2 5.25 0 7.24 2 1.99 5.25 2 7.24 0 1.99-2 2-5.25 0-7.24a.718.718 0 010-1.03c.29-.29.75-.29 1.03 0 2.57 2.57 2.57 6.75 0 9.31-2.57 2.56-6.75 2.57-9.31 0a6.594 6.594 0 01.01-9.31z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M14.24 9.76a6.564 6.564 0 011.74 6.22 6.585 6.585 0 01-11.05 3.09 6.585 6.585 0 010-9.31c.88-.89 1.96-1.46 3.09-1.74 2.16-.53 4.53.05 6.22 1.74z"
})));